import moment from 'moment';
export function parseStatsDate({
  strDate,
  month,
  year
}) {
  if (year) {
    if (month !== undefined) return moment(new Date(year, month - 1));
    return moment(new Date(year));
  }
  if (!strDate) return null;
  const parts = strDate.split('-');
  if (parts.length === 3) return moment(strDate);
  if (parts.length === 2) return moment(`${strDate}-1`);
  return null;
}